import { useState, useEffect, useReducer } from "react";
import { useParams, Link } from "react-router-dom";
import Button1 from "devextreme-react/button";
import { isEmpty, filter, find } from "lodash";
import TagBox from "devextreme-react/tag-box";
import { alert } from "devextreme/ui/dialog";
import * as actions from "../../actions/dashboard";
import smessReducer from "../../reducers/dashboard";

import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import { postUserLog } from "../../actions/common";

const iniState = { smessCards: null };

export default ({ shiftInfo, tierId, siteId, shiftNo, onClose, tierInfo }) => {
  const [clickedAttribute, setClickedAttribute] = useState();
  const [reasonCodes, setReasonCodes] = useState([]);
  const [cards, setCards] = useState([]);

  const [state, dispatch] = useReducer(smessReducer, iniState);

  const { sbg } = useParams();
  const { smessCards } = state;

  const CLRS = [
    "",
    "linear-gradient(180deg, rgba(27,148,33,1) 0%, rgba(9,115,11,1) 35%, rgba(26,67,28,1) 75%)",
    "linear-gradient(180deg, rgba(194,2,2,1) 0%, rgba(169,5,5,1) 35%, rgba(116,12,12,1) 75%)",
    "#666",
  ];

  useEffect(() => {
    actions.fetchSmessCards(dispatch, `${tierId}&shift=${shiftNo}`);
  }, []);

  useEffect(() => {
    if (smessCards) setCards(smessCards.cards);
  }, [smessCards]);

  useEffect(() => {
    if (!isEmpty(clickedAttribute)) {
      // Fetch Reason Code from API
      fetchReasonCodeForAttribute();
    }
  }, [clickedAttribute]);

  const onSave = () => {
    let data = [];
    let cardInfo = [...cards];
    if (!cardInfo.find((d) => d.status < 3)) {
      alert("Please answer the boxes before submitting.", "Alert");
      return;
    }
    cardInfo.forEach((d) => {
      data.push({
        tierID: tierId,
        shiftID: shiftNo,
        shiftTypeID: shiftInfo.isStdData ? 1 : 0,
        assessmentID: d.assessmentId,
        status: d.status,
        reasonIDs: d.status === 1 ? "" : d.reasonIDs ? String(d.reasonIDs) : "",
      });
    });
    actions.saveSmessCards(
      dispatch,
      { smessCards: data },
      { siteId, tierId, shiftNo }
    );
    onClose();
  };

  const getReasonCodeByReasonId = (reasonId) => {
    return;
  };

  const onCardSelect = (i, card) => {
    let cardInfo = [...cards];
    cardInfo[i].status = cardInfo[i].status == 1 ? 2 : 1;
    if (cardInfo[i].status === 2) {
      setClickedAttribute(() => cardInfo[i]);
    }
    setCards(cardInfo);
    if (cardInfo[i].status === 1 || cardInfo[i].status === 2) {
      postUserLog({
        event: `SMESS Selection`,
        data: {
          action: `${cardInfo[i].title} - ${
            cardInfo[i].status === 1 ? "Green" : "Red"
          }`,
          module: "Digital Tier",
          section: `${tierInfo?.tierName} SMESS Pop-up`,
          siteUId: siteId,
          widget: "SMESS",
          tierId,
        },
      });
    }
  };

  const fetchReasonCodeForAttribute = async () => {
    const reasonCodeData = await AsyncCallHandler(
      `/SMESS/getReasonCodesbyAssessmentID?assessmentId=${clickedAttribute.assessmentId}`,
      NEXUS_CONST.GET
    );
    const uniqueReasonCodes = [...reasonCodes];
    reasonCodeData.data.map((reasonCode) => {
      if (
        !find(
          uniqueReasonCodes,
          (reason) => reason.reasonID === reasonCode.reasonID
        )
      ) {
        uniqueReasonCodes.push(reasonCode);
      }
    });
    setReasonCodes(uniqueReasonCodes);
  };

  return (
    <div style={{ marginRight: "10px" }}>
      <div className="smes-cards">
        {cards.map((d, i) => (
          <div key={i} className="cards" style={{ background: CLRS[d.status] }}>
            <div
              onClick={() => onCardSelect(i, d)}
              style={{
                zIndex: 1,
                position: "absolute",
                width: "100%",
                height: "100%",
                textAlign: "center",
                top: `${d.status === 2 ? "30%" : "40%"}`,
              }}
            >
              {d.title}
            </div>
            {d.status === 2 && (
              <div
                style={{
                  zIndex: 10,
                  position: "absolute",
                  top: "50%",
                  width: "100%",
                }}
              >
                <TagBox
                  items={filter(
                    reasonCodes,
                    (reason) => reason.assessmentID === d.assessmentId
                  )}
                  valueExpr="reasonID"
                  displayExpr="reason"
                  placeholder="Select Reason Code"
                  searchEnabled={true}
                  wrapItemText={true}
                  maxDisplayedTags={1}
                  onValueChanged={(e) => {
                    const assessMentInfo = [...cards];
                    assessMentInfo[
                      assessMentInfo.findIndex(
                        (obj) => obj.assessmentId === d.assessmentId
                      )
                    ].reasonIDs = e.value;

                    setCards(() => assessMentInfo);
                    const card = assessMentInfo.filter(
                      (assessment) => assessment.assessmentId === d.assessmentId
                    )[0];

                    const reasons = card.reasonIDs.map((id) => {
                      return reasonCodes.filter(
                        (reason) => reason.reasonID === id
                      )[0]?.reason;
                    });
                    postUserLog({
                      event: `SMESS Selection`,
                      data: {
                        action: `${card.title} - ${
                          card.status === 1 ? "Green" : "Red"
                        } - Reason Code: ${reasons}`,
                        module: "Digital Tier",
                        section: `${tierInfo?.tierName} SMESS Pop-up`,
                        siteUId: siteId,
                        widget: "SMESS",
                        tierId,
                      },
                    });
                  }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="smess-act">
        <Link
          to={`/tiers/${sbg}/${siteId}/digital`}
          style={{ marginRight: "14px" }}
          onClick={() => {
            postUserLog({
              event: `SMESS Selection`,
              data: {
                action: `Clicked Back to Digital Tier Button`,
                module: "Digital Tier",
                section: `${tierInfo?.tierName} SMESS Pop-up`,
                siteUId: siteId,
                widget: "SMESS",
                tierId,
              },
            });
          }}
        >
          <Button1 text="Back to Digital Tier" type="normal" />
        </Link>
        <Button1
          style={{ marginRight: "14px" }}
          onClick={onSave}
          text="Submit"
          type="normal"
        />{" "}
      </div>
    </div>
  );
};
